import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=5400a085&scoped=true&"
import script from "./OtpInput.vue?vue&type=script&lang=js&"
export * from "./OtpInput.vue?vue&type=script&lang=js&"
import style0 from "./OtpInput.vue?vue&type=style&index=0&id=5400a085&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5400a085",
  null
  
)

export default component.exports